import * as React from 'react';
import './index.css';
import { SectionList } from '@wmfe/mach-pro-components-react';
import {
  debugLogData, debugRemoveLog, getAllLogTypes, handleLog, debugLogReportBusinessStep, getSelectedType, setDebugLogIsShow, debugLogIsShow
} from './Utils/debugGlobalData';

const EventCenter = Mach.requireModule('EventCenter');

interface ISectionData {
  key: string;
  data: { type: string; content: string; }[];
}
interface IState {
  showLog: boolean;
  debugFrameDetail: any;
  selectedType: string;
  debugSections: ISectionData[];
  isMini: boolean;
  isShow: boolean;
  isChooseisMini: boolean;
}

interface Props {
  title?: string;
}

// 外部页面追加日志用通知，首页用ref
export class SLDebugLogView extends React.Component<Props, IState> {
  startDebugFrameDetail: any
  debugIconRef: any
  logObserver: any
  list: any;
  userScroll: boolean = false
  private debounceRefresh: any;

  constructor(props) {
    super(props);

    this.state = {
      showLog: false,
      debugFrameDetail: { x: 10, y: Mach.env.screenHeight / 4 },
      selectedType: getSelectedType(),
      debugSections: this.log(),
      isMini: false,
      isShow: debugLogIsShow(),
      isChooseisMini: false
    };
  }

  componentDidMount(): void {
    if (!this.logObserver && Mach.env.isDebug) {
      // 外部页面追加日志
      this.logObserver = EventCenter.addListener(
        'sl_append_debug_log',
        (result) => {
          debugLogReportBusinessStep(result?.type, result?.key, result?.log);
          this.refresh();
        }
      );
    }
  }

  componentWillUnmount(): void {
    if (this.logObserver) {
      EventCenter.removeListener(this.logObserver);
      this.logObserver = null;
    }
  }

  log = (): ISectionData[] => [{
    key: 'section1',
    data: [...debugLogData()],
  }]

  // ref 追加日志
  public refresh = (time = 1000, com = () => {}) => {
    if (this.debounceRefresh) {
      clearTimeout(this.debounceRefresh);
    }

    this.debounceRefresh = setTimeout(() => {
      if ((this.state.showLog || this.state.isMini) && Mach.env.isDebug) {
        this.setState({
          debugSections: this.log(),
          selectedType: getSelectedType(),
        }, () => {
          this.scrollToBottom();
          if (com) {
            com();
          }
        });
      }
    }, time);
  }

  removeLog = () => {
    debugRemoveLog();
    this.refresh(0);
  }

  renderItem = (info: any) => {
    const index = info.indexPath?.item ?? info.index;
    return (
      <text
        className="debug-log" onClick={() => {
          if (this.state.isChooseisMini) {
            if (this.state.isMini) {
              this.setState({
                isMini: false,
                showLog: true
              });
            } else {
              this.setState({
                isMini: true,
                showLog: false
              });
            }
          } else {
            this.setState({
              showLog: false,
            });
          }
        }} content={`${index}. ${this.state.debugSections?.[0]?.data?.[index]?.content}`}
      />
    );
  };

  scrollToBottom = () => {
    // if (this.userScroll) {
    //     return
    // }
    setTimeout(() => {
      this.list?.scrollToItem?.({ section: 0, item: this.state.debugSections?.[0]?.data?.length - 2 }, { animated: false });
    }, 0);
  }

  renderList = () => (
    <view style={{ flex: 1, margin: '10 0' }}>
      <SectionList
        ref={(ref: any) => {
          if (ref) {
            this.list = ref;
          }
        }}
        itemKey={(v) => v.itemId}
        sections={this.state.debugSections}
        renderItem={this.renderItem}
        showScrollIndicator
        bounces
        selfSizingEnabled
        onScrollStart={() => {
          this.userScroll = true;
        }}
      />
    </view>
  )

  renderDebugType = () => (this.state.isShow || this.state.isMini || this.state.showLog ? (
    <view style={{ width: '100%', flexDirection: 'row' }}>
      {!this.state.isMini && <text className="debug-title" style={{ paddingRight: 10, fontSize: 16, flexShrink: 0 }} content="日志筛选:" />}
      <scroller className="debug-scroller" showScrollIndicator={false}>
        <content className="debug-content" flexibleWidth flexibleHeight>
          <view style={{ flexWrap: 'nowrap' }}>
            {getAllLogTypes()?.map((item) => (
              <text
                key={item} className={this.state.selectedType === item ? 'debug-item-title2' : 'debug-item-title'} content={this.state.selectedType === item ? `${item} [${this.state.debugSections?.[0]?.data?.length}条]` : item} onClick={() => {
                  this.userScroll = true;
                  this.setState({ selectedType: item }, () => {
                    handleLog(item).then(() => {
                      this.refresh(0);
                    });
                  });
                }}
              />
            ))}
          </view>
        </content>
      </scroller>
    </view>
  ) : null)

  renderDebugMinColse = () => (
    <text
      className={this.state.isChooseisMini ? 'debug-item-title2' : 'debug-item-title'} content={this.state.isChooseisMini ? '  关闭小窗口  ' : '  缩小窗口  '} onClick={() => {
        if (this.state.isChooseisMini) {
          this.setState({ debugSections: [] }, () => {
            this.list.reload();
            this.setState({
              debugSections: [], isMini: false, showLog: false, isChooseisMini: false
            }, () => {
            });
          });
        } else {
          this.setState({ isMini: true, isChooseisMini: true, showLog: false }, () => {
          });
        }
      }}
    />
  )

  close = () => {
    setDebugLogIsShow(false);
    this.setState({
      isShow: false
    }, () => {
      Mach.requireModule('Toast').show('👋🏻再见了我要回家~\n双击移除\n重启app生效哦', 3);
    });
  }

  shouldComponentUpdate(nextProps: Readonly<any>, nextState: Readonly<IState>, nextContext: any): boolean {
    return nextState.showLog !== this.state.showLog
               || nextState.debugFrameDetail !== this.state.debugFrameDetail
               || nextState.selectedType !== this.state.selectedType
               || nextState.debugSections !== this.state.debugSections
               || nextState.isMini !== this.state.isMini
               || nextState.isShow !== this.state.isShow
               || nextState.isChooseisMini !== this.state.isChooseisMini;
  }

  renderDebugLogView = () => {
    const {
      isMini, showLog, isShow, isChooseisMini
    } = this.state;
    return (
      <view
        className={isShow ? (isMini ? 'debug-open-log' : 'debug-icon') : 'debug-holder'}
        ref={(ref) => {
          if (ref) {
            this.debugIconRef = ref;
          }
        }}
        style={{ left: isMini ? (this.state.debugFrameDetail.x > Mach.env.screenWidth - 200 ? Mach.env.screenWidth - 210 : this.state.debugFrameDetail.x) : this.state.debugFrameDetail.x, top: this.state.debugFrameDetail.y }}
        onDragStart={(offset) => {
          const frame = this.debugIconRef.measureInWindow();
          this.startDebugFrameDetail = frame;
        }}
        onDrag={(offset) => {
          const x = offset.detail.x + this.startDebugFrameDetail.x;
          const y = offset.detail.y + this.startDebugFrameDetail.y;
          if (x > 0 && y > 0 && x < Mach.env.screenWidth - this.startDebugFrameDetail.width) {
            this.setState({
              debugFrameDetail: { x, y }
            });
          }
        }}
        onDoubleClick={() => {
          this.close();
        }}
        onClick={() => {
          this.userScroll = false;
          this.setState({
            showLog: true,
            debugSections: this.log()
          }, () => {
            this.scrollToBottom();
          });
        }}
      >
        {isShow && isMini && !showLog && isChooseisMini ? (
          <view style={{
            flexDirection: 'column', marginLeft: 10, marginRight: 10, paddingTop: 10, paddingBottom: 10, alignItems: 'center'
          }}
          >
            {this.renderDebugType()}
            {this.renderList()}
            {this.renderDebugMinColse()}</view>
        ) : <text className="debug-icon-text" content={this.props.title ? `${this.props.title}\n日志` : '日志'} />}
        {isShow && showLog && !isMini && (
          <modal
            onClick={() => {
              if (this.state.isChooseisMini) {
                this.setState({
                  isMini: true,
                  showLog: false,
                });
              } else {
                this.setState({
                  showLog: false,
                });
              }
            }}
            style={{
              backgroundColor: '#000000d8',
            }}
          >
            <view className="debug-modal-wrapper" style={{ paddingTop: Mach.env?.statusBarHeight, paddingBottom: Mach.env.softMenuBarHeight }}>
              <view style={{ justifyContent: 'space-between', width: '100%', marginBottom: 10 }}>
                <text
                  className="debug-title" style={{ }} content={`${this.props.title || ''}日志:`} onLongPress={() => {
                    this.close();
                  }}
                />
                {this.state.debugSections?.[0]?.data?.length && (
                  <text
                    className="debug-title" style={{ fontSize: 14 }} content=" ❌清空日志" onClick={() => {
                      this.removeLog();
                    }}
                  />
                )}
              </view>
              {this.renderDebugType()}
              {this.renderList()}
              <view style={{ flexDirection: 'column', alignItems: 'center' }}>
                <view>
                  <text
                    className="debug-item-title" style={{ paddingRight: 20, paddingLeft: 20 }} content=" ↑ 置顶 " onClick={() => {
                      this.userScroll = true;
                      this.list?.scrollToItem?.({ section: 0, item: 0 });
                    }}
                  />
                  <text
                    className="debug-item-title" style={{ paddingRight: 20, paddingLeft: 20 }} content=" ↓ 置底 " onClick={() => {
                      this.userScroll = true;
                      this.list?.scrollToItem?.({ section: 0, item: this.state.debugSections?.[0]?.data?.length - 2 });
                    }}
                  />
                  {this.renderDebugMinColse()}
                </view>
                <view style={{ flex: 1, alignItems: 'center', justifyContent: 'center' }}>
                  <text
                    className="debug-title" style={{
                      fontSize: 16, marginBottom: Mach.env.safeAreaInsets.bottom, alignSelf: 'center', paddingTop: 10,
                    }} content="点击移除"
                  />
                </view>
              </view>
            </view>
          </modal>
        )}
      </view>
    );
  }

  render() {
    return Mach.env.isDebug ? this.renderDebugLogView() : null;
  }
}
